import { t } from 'ftc-common/i18n';
import { Carousel } from 'react-bootstrap';
import Sponsor from './Sponsor'

const SLIDE_INTERVAL_MS = 5000;

export default function SponsorList({sponsors}) {
    if(sponsors.length === 0) return null;
    return <>
        {/* Sponsor logos only: override prefers-reduced-motion so the slide always runs. */}
        <style>{`
            @media (prefers-reduced-motion: reduce) {
                #sponsorCarousel .carousel-item {
                    transition: transform 0.6s ease-in-out;
                }
            }
        `}</style>
        <h3>{t`Thank you to our sponsors!`}</h3>
        <Carousel
            id="sponsorCarousel"
            interval={SLIDE_INTERVAL_MS}
            controls={false}
            indicators={false}
            pause="hover"
            wrap
            slide
            touch
        >
            {sponsors.map((sponsor) => (
                <Carousel.Item key={sponsor.sponsorId} style={{height: '230px'}}>
                    <Sponsor sponsor={sponsor}/>
                </Carousel.Item>
            ))}
        </Carousel>
    </>;
}
